module.exports = __webpack_public_path__ + "static/img/two_1140shanghaiwenyichubanse.d3bce35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_1140shanghaiwenyichubanse.jpg
// module id = 0rFU
// module chunks = 36